import { call, put } from 'redux-saga/effects';
import {
  fetchOrganisationContactsRequest,
  updateExcelContactFailure,
  updateExcelContactSuccess,
} from '../actions';
import { updateExcelContact } from '../api';
import { UpdateExcelContactRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateExcelContactSaga(
  action: UpdateExcelContactRequestAction
) {
  try {
    const { organisationId, contactUuid, excelContact } = action.payload;

    const response: ApiResponse = yield call(
      updateExcelContact,
      organisationId,
      contactUuid,
      excelContact
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(updateExcelContactSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(fetchOrganisationContactsRequest(organisationId));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateExcelContactFailure());
  }
}
